import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const Home = lazy(() => import("./web/Home.js").then((m) => ({ default: m.Home })));
const WeatherPage = lazy(() => import("./web/WeatherPage.js").then((m) => ({ default: m.WeatherPage })));

export default defineWebModule({ manifest, pages: { "": Home, "/weather": WeatherPage } });
